export enum AutoscrollOrientationEnum {
  /**По вертикали */
  Vertical = "vertical",
  /**По горизонтали */
  Horizontal = "horizontal",
  /**По вертикали и горизонтали */
  Both = "both",
}
